import { Component, EventEmitter, inject, OnInit, Output, signal, computed } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SearcherComponent } from '../../content/searcher/searcher.component';
import { ContentStateService } from '../../content/content-state.service';
import { ContentService } from '../../content/content.service';
import { VersionTileComponent } from 'src/app/shared/components/ui/version-tile/version-tile.component';
import { SearchProcessorService } from '../../content/searcher/search-processor.service';

import { ConfirmMenuService } from 'src/app/shared/services/confirm-menu/confirm-menu.service';
import { SearchChatComponent } from '../../content/searcher/search-chat/search-chat.component';

@Component({
  selector: 'app-questions-search-sidebar',
  templateUrl: './questions-search-sidebar.component.html',
  styleUrls: ['./questions-search-sidebar.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule, SearcherComponent, VersionTileComponent, SearchChatComponent],
})
export class QuestionsSearchSidebarComponent implements OnInit {
  private contentStateService = inject(ContentStateService);
  private contentService = inject(ContentService);
  private searchProcessor = inject(SearchProcessorService);
  private translate = inject(TranslateService);
  private confirmMenuService = inject(ConfirmMenuService);
  @Output() close = new EventEmitter<void>();

  history = signal<any[]>([]);
  currentSearchId = signal<string | null>(null);
  viewMode = signal<'SEARCH' | 'CHAT'>('SEARCH');
  selectedSession = signal<any>(null);

  formattedHistory = computed(() => {
    return this.history().map((item) => ({
      _id: item._id,
      instruction: item.query,
      createdAt: item.createdAt,
      originalItem: item,
    }));
  });

  ngOnInit() {
    this.loadHistory();
  }

  loadHistory() {
    this.contentService.getSearchHistory().subscribe((res) => {
      this.history.set(res || []);
    });
  }

  onSearchCompleted(results: any) {
    this.contentStateService.setSearchResults(results);
    this.contentStateService.setSearchOpen(true);
    this.loadHistory();
    this.currentSearchId.set(null);
  }

  onAiStreamUpdate(text: string) {
    this.contentStateService.setSearchResults({
      editions: [],
      finalAIResponse: '',
      temporaryAnswer: text,
      searchType: 'ai_gemini',
      loading: true,
    });
    this.contentStateService.setSearchOpen(true);
  }

  restoreSearch(version: any) {
    const item = version.originalItem;
    this.currentSearchId.set(item._id);
    this.contentStateService.setSearchResults({ loading: true });
    this.contentStateService.setSearchOpen(true);

    this.contentService.getSearchDetails(item._id).subscribe(async (res) => {
      const editions = await this.searchProcessor.processSearchResults(res, this.translate.currentLang);

      this.contentStateService.setSearchResults({
        editions: editions,
        finalAIResponse: res.AIResponse || '',
        temporaryAnswer: '',
        searchType: res.type || 'text',
        loading: false,
      });
    });
  }

  openChat(version: any) {
    const item = version.originalItem;
    this.currentSearchId.set(item._id);
    this.contentService.getSearchDetails(item._id).subscribe((res) => {
      this.selectedSession.set(res);
      this.viewMode.set('CHAT');
    });
  }

  onSessionUpdated(updatedSession: any) {
    this.selectedSession.set(updatedSession);
    this.loadHistory();
  }

  deleteSearch(trigger: HTMLElement, version: any) {
    this.confirmMenuService.confirm(trigger, 'Global.AreYouSure').subscribe(() => {
      this.contentService.deleteSearchHistoryItem(version._id).subscribe(() => {
        this.loadHistory();
      });
    });
  }

  closeSidebar() {
    this.close.emit();
    this.contentStateService.openQuestionsSearchSidebar(false);
  }
}
